import React from "react";
import {
  defineBlock,
  smartProps,
  useSmartProp,
  useInspectorControl,
} from "@smartfire/gutenberg-react";
import EditableText from "../shared/editable-text";
import style from "./block.module.scss";
import {
  PanelBody,
  PanelRow,
  TextControl,
  ToggleControl,
} from "@wordpress/components";
import { ReactComponent as Arrow } from "../assets/arrow_right.svg";

function Inspector() {
  const [color, setColor] = useSmartProp("color");
  const [url, setUrl] = useSmartProp("url");
  const [urlText, setUrlText] = useSmartProp("urlText");
  const [barActive, setBarActive] = useSmartProp("barActive");
  const [colorEndBar, setColorEndBar] = useSmartProp("colorEndBar");
  return (
    <>
      <PanelBody title="Configuration Lien" initialOpen={true}>
        <PanelRow>
          <TextControl
            label={"Lien"}
            value={url}
            onChange={(value) => setUrl(value)}
          />
        </PanelRow>
        <PanelRow>
          <TextControl
            label={"Texte du lien"}
            value={urlText}
            onChange={(value) => setUrlText(value)}
          />
        </PanelRow>
      </PanelBody>
      <PanelBody title="Configuration couleur" initialOpen={true}>
        <PanelRow>
          <ToggleControl
            label="Couleur du fond"
            help={color === "blue" ? "Fond bleu" : "Fond blanc"}
            checked={color === "blue"}
            onChange={() => setColor(color === "blue" ? "white" : "blue")}
          />
        </PanelRow>
      </PanelBody>
      <PanelBody title="Configuration barre bas" initialOpen={true}>
        <PanelRow>
          <ToggleControl
            label="Activation"
            help={barActive ? "Barre active" : "Barre non active"}
            checked={barActive}
            onChange={() => setBarActive(barActive ? false : true)}
          />
        </PanelRow>
        <PanelRow>
          <TextControl
            label={"Couleur après barre"}
            value={colorEndBar}
            onChange={(value) => setColorEndBar(value)}
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ url, urlText, color, barActive, colorEndBar }) {
  useInspectorControl(Inspector);
  return (
    <>
      <div className={color === "blue" ? style.blue : style.white}>
        <div className={style.content}>
          <EditableText
            className={style.title}
            tagName="h2"
            smartProp="title"
          />
          <div className={style.bar} />
          <EditableText className={style.text} smartProp="text" />
          {url && (
            <a className={style.link} href={url}>
              {urlText}
              <Arrow />
            </a>
          )}
        </div>
      </div>
      <div
        className={barActive ? style.barBottom : style.none}
        style={{
          background: `linear-gradient(to right, ${style.darkOrange} 70%, ${colorEndBar} 70%)`,
        }}
      />
    </>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault(""),
    text: smartProps.string.withDefault(""),
    url: smartProps.string.withDefault(""),
    urlText: smartProps.string.withDefault(""),
    color: smartProps.string.withDefault("blue"),
    barActive: smartProps.string.withDefault(false),
    colorEndBar: smartProps.string.withDefault("#F8F8F8"),
  },
  setup: {
    title: "Texte Simple",
  },
});
